import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatAuthorizationDates',
})
export class FormatAuthorizationDatesPipe implements PipeTransform {
  private datePipe = new DatePipe('en-US');

  transform(text: string): string {
    if (!text) return '';

    return text.replace(
      /\(Effective Date: (.*?), Expiration Date: (.*?)\)/,
      (_, effDate, expDate) => {
        const formattedEffDate = this.datePipe.transform(effDate, 'MMMM d, y');
        const formattedExpDate = this.datePipe.transform(expDate, 'MMMM d, y');
        return `(Effective Date: ${formattedEffDate}, Expiration Date: ${formattedExpDate})`;
      }
    );
  }
}
